/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.7.0 (NJsonSchema v10.6.7.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// @ts-nocheck

import { ApiClientBase } from '@services/api-client-base';
import { TransferHttpService } from '@services/transfer-http.service';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const BACKEND_API_BASE_URL = new InjectionToken<string>('BACKEND_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class ArticlesClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(BACKEND_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5001";
    }

    getRemovedList(page?: number | undefined, perPage?: number | undefined): Observable<IListMethodResultOfPostDto> {
        let url_ = this.baseUrl + "/api/articles/get-removed?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRemovedList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRemovedList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IListMethodResultOfPostDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IListMethodResultOfPostDto>;
        }));
    }

    protected processGetRemovedList(response: HttpResponseBase): Observable<IListMethodResultOfPostDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IListMethodResultOfPostDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCreateModel(): Observable<PageViewModel> {
        let url_ = this.baseUrl + "/api/articles/get-create";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCreateModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreateModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageViewModel>;
        }));
    }

    protected processGetCreateModel(response: HttpResponseBase): Observable<PageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PageViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEditModel(id: string): Observable<PageViewModel> {
        let url_ = this.baseUrl + "/api/articles/get-edit-model/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEditModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageViewModel>;
        }));
    }

    protected processGetEditModel(response: HttpResponseBase): Observable<PageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PageViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    softRemove(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/articles/soft-remove?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSoftRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSoftRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSoftRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    recover(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/articles/recover?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRecover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecover(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getList(page?: number | undefined, perPage?: number | undefined): Observable<IListMethodResultOfPostDto> {
        let url_ = this.baseUrl + "/api/articles/get-list?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IListMethodResultOfPostDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IListMethodResultOfPostDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<IListMethodResultOfPostDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IListMethodResultOfPostDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(model: PageViewModel): Observable<string> {
        let url_ = this.baseUrl + "/api/articles/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: PageViewModel): Observable<void> {
        let url_ = this.baseUrl + "/api/articles/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    remove(id: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/articles/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(BACKEND_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5001";
    }

    login(model: LoginRequestModel): Observable<LoginResult> {
        let url_ = this.baseUrl + "/api/auth/sign-in";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginResult>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<LoginResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isAuthenticated(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/auth/is-authenticated";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processIsAuthenticated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsAuthenticated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsAuthenticated(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestPasswordReset(loginOrEmail: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/auth/request-password-reset?";
        if (loginOrEmail === undefined || loginOrEmail === null)
            throw new Error("The parameter 'loginOrEmail' must be defined and cannot be null.");
        else
            url_ += "loginOrEmail=" + encodeURIComponent("" + loginOrEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestPasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestPasswordReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRequestPasswordReset(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmRegistration(userId: string, emailToken: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/auth/confirm-registration?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (emailToken === undefined || emailToken === null)
            throw new Error("The parameter 'emailToken' must be defined and cannot be null.");
        else
            url_ += "emailToken=" + encodeURIComponent("" + emailToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processConfirmRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmRegistration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processConfirmRegistration(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    continuePasswordReset(userId: string, password: string, token: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/auth/continue-password-reset?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processContinuePasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContinuePasswordReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processContinuePasswordReset(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmEmail(userId: string, token: string, email: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/auth/confirm-email?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logout(): Observable<LogoutResult> {
        let url_ = this.baseUrl + "/api/auth/sign-out";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogoutResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogoutResult>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<LogoutResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LogoutResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCurrentUserInfo(): Observable<CurrentUserInfo> {
        let url_ = this.baseUrl + "/api/auth/get-current-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentUserInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentUserInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentUserInfo>;
        }));
    }

    protected processGetCurrentUserInfo(response: HttpResponseBase): Observable<CurrentUserInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CurrentUserInfo;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CategoriesClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(BACKEND_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5001";
    }

    getCreateModel(): Observable<CategoryViewModel> {
        let url_ = this.baseUrl + "/api/categories/get-create";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCreateModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreateModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryViewModel>;
        }));
    }

    protected processGetCreateModel(response: HttpResponseBase): Observable<CategoryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoryViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEditModel(id: string): Observable<CategoryViewModel> {
        let url_ = this.baseUrl + "/api/categories/get-edit-model/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEditModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryViewModel>;
        }));
    }

    protected processGetEditModel(response: HttpResponseBase): Observable<CategoryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoryViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getList(page?: number | undefined, perPage?: number | undefined): Observable<IListMethodResultOfCategory> {
        let url_ = this.baseUrl + "/api/categories/get-list?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IListMethodResultOfCategory>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IListMethodResultOfCategory>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<IListMethodResultOfCategory> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IListMethodResultOfCategory;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(model: CategoryViewModel): Observable<string> {
        let url_ = this.baseUrl + "/api/categories/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: CategoryViewModel): Observable<void> {
        let url_ = this.baseUrl + "/api/categories/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    remove(id: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/categories/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DashboardClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(BACKEND_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5001";
    }

    getPageModel(): Observable<DashboardPageViewModel> {
        let url_ = this.baseUrl + "/api/dashboard/get-page-model";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPageModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPageModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardPageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardPageViewModel>;
        }));
    }

    protected processGetPageModel(response: HttpResponseBase): Observable<DashboardPageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DashboardPageViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EventsClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(BACKEND_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5001";
    }

    getRemovedList(page?: number | undefined, perPage?: number | undefined): Observable<IListMethodResultOfPostDto> {
        let url_ = this.baseUrl + "/api/events/get-removed?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRemovedList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRemovedList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IListMethodResultOfPostDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IListMethodResultOfPostDto>;
        }));
    }

    protected processGetRemovedList(response: HttpResponseBase): Observable<IListMethodResultOfPostDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IListMethodResultOfPostDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCreateModel(): Observable<EventViewModel> {
        let url_ = this.baseUrl + "/api/events/get-create";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCreateModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreateModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventViewModel>;
        }));
    }

    protected processGetCreateModel(response: HttpResponseBase): Observable<EventViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEditModel(id: string): Observable<EventViewModel> {
        let url_ = this.baseUrl + "/api/events/get-edit-model/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEditModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EventViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EventViewModel>;
        }));
    }

    protected processGetEditModel(response: HttpResponseBase): Observable<EventViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EventViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    softRemove(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/events/soft-remove?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSoftRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSoftRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSoftRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    recover(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/events/recover?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRecover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecover(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getList(page?: number | undefined, perPage?: number | undefined): Observable<IListMethodResultOfPostDto> {
        let url_ = this.baseUrl + "/api/events/get-list?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IListMethodResultOfPostDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IListMethodResultOfPostDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<IListMethodResultOfPostDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IListMethodResultOfPostDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(model: EventViewModel): Observable<string> {
        let url_ = this.baseUrl + "/api/events/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: EventViewModel): Observable<void> {
        let url_ = this.baseUrl + "/api/events/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    remove(id: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/events/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FileSystemClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(BACKEND_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5001";
    }

    getRootDirectory(): Observable<DirectoryViewModel> {
        let url_ = this.baseUrl + "/api/fs/get-root-dir";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRootDirectory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRootDirectory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DirectoryViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DirectoryViewModel>;
        }));
    }

    protected processGetRootDirectory(response: HttpResponseBase): Observable<DirectoryViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DirectoryViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upload(files?: FileParameter[] | null | undefined): Observable<UploadResultViewModel> {
        let url_ = this.baseUrl + "/api/fs/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadResultViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadResultViewModel>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<UploadResultViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UploadResultViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listDirectory(path?: string | null | undefined): Observable<IndexFilesViewModel> {
        let url_ = this.baseUrl + "/api/fs/list-directory?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processListDirectory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListDirectory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IndexFilesViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IndexFilesViewModel>;
        }));
    }

    protected processListDirectory(response: HttpResponseBase): Observable<IndexFilesViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IndexFilesViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createFolder(model: CreateFolderViewModel): Observable<void> {
        let url_ = this.baseUrl + "/api/fs/create-folder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateFolder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFolder(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/fs/delete-folder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFolder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFile(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/fs/delete-file?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadFile(path?: string | null | undefined, files?: FileParameter[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/fs/upload-files?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadBase64Image(base64Image: string, pageType: string | null): Observable<string> {
        let url_ = this.baseUrl + "/api/fs/upload-base64-image?";
        if (pageType === undefined)
            throw new Error("The parameter 'pageType' must be defined.");
        else if(pageType !== null)
            url_ += "pageType=" + encodeURIComponent("" + pageType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(base64Image);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadBase64Image(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBase64Image(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadBase64Image(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FroalaClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(BACKEND_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5001";
    }

    getImages(folder: string | null): Observable<FroalaImagesResult[]> {
        let url_ = this.baseUrl + "/api/froala/get-images/{folder}";
        if (folder === undefined || folder === null)
            throw new Error("The parameter 'folder' must be defined.");
        url_ = url_.replace("{folder}", encodeURIComponent("" + folder));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FroalaImagesResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FroalaImagesResult[]>;
        }));
    }

    protected processGetImages(response: HttpResponseBase): Observable<FroalaImagesResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FroalaImagesResult[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadFile(dirName: string | null, contentType?: string | null | undefined, contentDisposition?: string | null | undefined, headers?: IHeaderDictionary | null | undefined, length?: number | undefined, name?: string | null | undefined, fileName?: string | null | undefined): Observable<FroalaUploadResult> {
        let url_ = this.baseUrl + "/api/froala/upload-file/{dirName}";
        if (dirName === undefined || dirName === null)
            throw new Error("The parameter 'dirName' must be defined.");
        url_ = url_.replace("{dirName}", encodeURIComponent("" + dirName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            content_.append("Headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FroalaUploadResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FroalaUploadResult>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<FroalaUploadResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FroalaUploadResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteImage(id?: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/froala/delete-image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("id", id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteImage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LeadersClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(BACKEND_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5001";
    }

    getAll(): Observable<Leader[]> {
        let url_ = this.baseUrl + "/api/leaders/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Leader[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Leader[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Leader[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Leader[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(leaders: Leader[]): Observable<void> {
        let url_ = this.baseUrl + "/api/leaders/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(leaders);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NewsClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(BACKEND_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5001";
    }

    getRemovedList(page?: number | undefined, perPage?: number | undefined): Observable<IListMethodResultOfPostDto> {
        let url_ = this.baseUrl + "/api/news/get-removed?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRemovedList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRemovedList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IListMethodResultOfPostDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IListMethodResultOfPostDto>;
        }));
    }

    protected processGetRemovedList(response: HttpResponseBase): Observable<IListMethodResultOfPostDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IListMethodResultOfPostDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCreateModel(): Observable<NewsViewModel> {
        let url_ = this.baseUrl + "/api/news/get-create";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCreateModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreateModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewsViewModel>;
        }));
    }

    protected processGetCreateModel(response: HttpResponseBase): Observable<NewsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewsViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEditModel(id: string): Observable<NewsViewModel> {
        let url_ = this.baseUrl + "/api/news/get-edit-model/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEditModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewsViewModel>;
        }));
    }

    protected processGetEditModel(response: HttpResponseBase): Observable<NewsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewsViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    softRemove(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/news/soft-remove?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSoftRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSoftRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSoftRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    recover(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/news/recover?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRecover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecover(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getList(page?: number | undefined, perPage?: number | undefined): Observable<IListMethodResultOfPostDto> {
        let url_ = this.baseUrl + "/api/news/get-list?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IListMethodResultOfPostDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IListMethodResultOfPostDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<IListMethodResultOfPostDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IListMethodResultOfPostDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(model: NewsViewModel): Observable<string> {
        let url_ = this.baseUrl + "/api/news/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: NewsViewModel): Observable<void> {
        let url_ = this.baseUrl + "/api/news/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    remove(id: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/news/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PersonClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(BACKEND_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5001";
    }

    getCreateModel(): Observable<CreatePersonsViewModel> {
        let url_ = this.baseUrl + "/api/person/get-create";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCreateModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreateModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePersonsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePersonsViewModel>;
        }));
    }

    protected processGetCreateModel(response: HttpResponseBase): Observable<CreatePersonsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePersonsViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEditModel(id: string): Observable<EditPersonsViewModel> {
        let url_ = this.baseUrl + "/api/person/get-edit-model/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEditModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditPersonsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditPersonsViewModel>;
        }));
    }

    protected processGetEditModel(response: HttpResponseBase): Observable<EditPersonsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EditPersonsViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getList(page?: number | undefined, perPage?: number | undefined): Observable<IListMethodResultOfPerson> {
        let url_ = this.baseUrl + "/api/person/get-list?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IListMethodResultOfPerson>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IListMethodResultOfPerson>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<IListMethodResultOfPerson> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IListMethodResultOfPerson;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(model: BasePersonEditViewModel): Observable<string> {
        let url_ = this.baseUrl + "/api/person/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: BasePersonEditViewModel): Observable<void> {
        let url_ = this.baseUrl + "/api/person/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    remove(id: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/person/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProfessorClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(BACKEND_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5001";
    }

    getAll(): Observable<ProfessorHomeListViewModel[]> {
        let url_ = this.baseUrl + "/api/professor/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessorHomeListViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessorHomeListViewModel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProfessorHomeListViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfessorHomeListViewModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCreateModel(): Observable<BaseProfessorViewModel> {
        let url_ = this.baseUrl + "/api/professor/get-create";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCreateModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreateModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseProfessorViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseProfessorViewModel>;
        }));
    }

    protected processGetCreateModel(response: HttpResponseBase): Observable<BaseProfessorViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseProfessorViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEditModel(id: string): Observable<BaseProfessorViewModel> {
        let url_ = this.baseUrl + "/api/professor/get-edit-model/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEditModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseProfessorViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseProfessorViewModel>;
        }));
    }

    protected processGetEditModel(response: HttpResponseBase): Observable<BaseProfessorViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseProfessorViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getList(page?: number | undefined, perPage?: number | undefined): Observable<IListMethodResultOfProfessor> {
        let url_ = this.baseUrl + "/api/professor/get-list?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IListMethodResultOfProfessor>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IListMethodResultOfProfessor>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<IListMethodResultOfProfessor> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IListMethodResultOfProfessor;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(model: BaseProfessorViewModel): Observable<string> {
        let url_ = this.baseUrl + "/api/professor/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: BaseProfessorViewModel): Observable<void> {
        let url_ = this.baseUrl + "/api/professor/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    remove(id: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/professor/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SettingsClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(BACKEND_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5001";
    }

    getIndexModel(): Observable<IndexSettingsViewModel> {
        let url_ = this.baseUrl + "/api/settings/get-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetIndexModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIndexModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IndexSettingsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IndexSettingsViewModel>;
        }));
    }

    protected processGetIndexModel(response: HttpResponseBase): Observable<IndexSettingsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IndexSettingsViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveSettings(model: IndexSettingsViewModel): Observable<void> {
        let url_ = this.baseUrl + "/api/settings/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UsersClient extends ApiClientBase {
    private http: TransferHttpService;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TransferHttpService) http: TransferHttpService, @Optional() @Inject(BACKEND_API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:5001";
    }

    getList(page?: number | undefined, perPage?: number | undefined): Observable<IListMethodResultOfUserDto> {
        let url_ = this.baseUrl + "/api/users/get-list?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IListMethodResultOfUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IListMethodResultOfUserDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<IListMethodResultOfUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IListMethodResultOfUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCreateModel(): Observable<BaseUserEditViewModel> {
        let url_ = this.baseUrl + "/api/users/get-create";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCreateModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreateModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseUserEditViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseUserEditViewModel>;
        }));
    }

    protected processGetCreateModel(response: HttpResponseBase): Observable<BaseUserEditViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseUserEditViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEditModel(id: string): Observable<BaseUserEditViewModel> {
        let url_ = this.baseUrl + "/api/users/get-edit-model/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEditModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseUserEditViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseUserEditViewModel>;
        }));
    }

    protected processGetEditModel(response: HttpResponseBase): Observable<BaseUserEditViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseUserEditViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    requestPasswordReset(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/users/request-password-reset/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestPasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestPasswordReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestPasswordReset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(model: BaseUserEditViewModel): Observable<string> {
        let url_ = this.baseUrl + "/api/users/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: BaseUserEditViewModel): Observable<void> {
        let url_ = this.baseUrl + "/api/users/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    remove(id: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/users/remove/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse || response.body
              ? (Object.prototype.toString.apply(response.body) === '[object String]' ? new Blob([response.body], {type: 'text/plain'}) : response.body)
              : (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: Record<string, string> = {};
        if (response.headers) {
          if (response.headers instanceof HttpHeaders) {
            for (let key of response.headers.keys()) {
              _headers[key] = response.headers.get(key);
            }
          } else {
            _headers = {...response.headers};
          }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IListMethodResultOfPostDto {
    items?: PostDto[] | null;
    pagesCount?: number;
}

export interface PostDto {
    id?: string;
    title?: string | null;
    publishedAt?: Date;
    published?: boolean;
    deleted?: boolean;
    link?: string | null;
    onMainPage?: boolean;
    postTypeAlias?: string | null;
}

export interface CommonAdminPageViewModel {
    pageTitle?: PageTitleViewModel | null;
    topMenu?: MenuLink[] | null;
    appVersion?: string | null;
}

export interface AdminPageBaseViewModel extends CommonAdminPageViewModel {
    leftMenu?: MenuLink[] | null;
}

export interface PostViewModel extends AdminPageBaseViewModel {
    id: string;
    title: string;
    excerpt?: string | null;
    content: string;
    published?: boolean;
    deleted?: boolean;
    publishDate?: Date;
    authorId?: string;
    postTypeId?: string;
    selectedCategories?: string[] | null;
    isCommentsAllowed?: boolean;
    canBeRated?: boolean;
    postOnStartPage?: boolean;
    previewImageId?: string | null;
    url: string;
    seoTitle: string;
    seoDescription: string;
    categories?: SelectListItem[] | null;
    authors?: SelectListItem[] | null;
}

export interface PageViewModel extends PostViewModel {
}

export interface SelectListItem {
    disabled?: boolean;
    group?: SelectListGroup | null;
    selected?: boolean;
    text?: string | null;
    value?: string | null;
}

export interface SelectListGroup {
    disabled?: boolean;
    name?: string | null;
}

export interface MenuLink {
    alias?: string | null;
    isActive?: boolean;
    url?: string | null;
    displayingTitle?: string | null;
    alt?: string | null;
}

export interface PageTitleViewModel {
    title?: string | null;
    delimiter?: string | null;
    siteName?: string | null;
}

export interface ErrorResponse {
    code?: number;
    message?: string | null;
}

export interface LoginResult {
    loginStatus: LoginResults;
    description: string;
}

export enum LoginResults {
    Success = 0,
    WrongPasswordOrDoesntExists = 1,
    AlreadySignedIn = 2,
    UnexpectedError = 3,
}

export interface LoginRequestModel {
    login: string;
    password: string;
}

export interface LogoutResult {
    logoutStatus: LogoutResults;
    description: string;
}

export enum LogoutResults {
    Success = 0,
    NotLoggedIn = 1,
    Error = 2,
}

export interface CurrentUserInfo {
    login?: string | null;
}

export interface CategoryViewModel extends AdminPageBaseViewModel {
    id?: string | null;
    name: string;
    description?: string | null;
    alias: string;
    disableAliasInput?: boolean;
}

export interface IListMethodResultOfCategory {
    items?: Category[] | null;
    pagesCount?: number;
}

export interface EntityOfGuid {
    id?: string;
    creationDate?: Date;
}

export interface EntityWithNameAndAliasOfGuid extends EntityOfGuid {
    name?: string | null;
    alias?: string | null;
}

export interface EntityWithNameAndAlias extends EntityWithNameAndAliasOfGuid {
}

export interface Category extends EntityWithNameAndAlias {
    description?: string | null;
    postCategories?: PostCategory[] | null;
}

export interface EntityWithGuidKey extends EntityOfGuid {
}

export interface PostCategory extends EntityWithGuidKey {
    categoryId?: string;
    category?: Category | null;
    postId?: string;
    post?: Post | null;
}

export interface Post extends EntityWithGuidKey {
    title?: string | null;
    excerpt?: string | null;
    content?: string | null;
    published?: boolean;
    deleted?: boolean;
    publishDate?: Date;
    postTypeId?: string;
    authorId?: string;
    author?: User | null;
    postType?: PostType | null;
    postSettingsId?: string | null;
    postSettings?: PostSetting | null;
    postSeoSettingsId?: string;
    postSeoSetting?: PostSeoSetting | null;
    postCategories?: PostCategory[] | null;
    postAttachments?: PostAttachment[] | null;
}

export interface IdentityUserOfGuid {
    id?: string;
    userName?: string | null;
    normalizedUserName?: string | null;
    email?: string | null;
    normalizedEmail?: string | null;
    emailConfirmed?: boolean;
    passwordHash?: string | null;
    securityStamp?: string | null;
    concurrencyStamp?: string | null;
    phoneNumber?: string | null;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | null;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
}

export interface User extends IdentityUserOfGuid {
    creationDate?: Date;
    person?: Person | null;
    personId?: string;
    posts?: Post[] | null;
    settings?: UserSetting[] | null;
}

export interface Person extends EntityWithGuidKey {
    name?: string | null;
    surname?: string | null;
    middleName?: string | null;
    phone?: string | null;
    additionalPhone?: string | null;
    birthday?: Date;
    photoId?: string | null;
    photo?: MathFile | null;
    user?: User | null;
    professor?: Professor | null;
}

export interface EntityWithNameOfGuid extends EntityOfGuid {
    name?: string | null;
}

export interface EntityWithName extends EntityWithNameOfGuid {
}

export interface MathFile extends EntityWithName {
    path?: string | null;
    extension?: string | null;
    hash?: string | null;
    person?: Person | null;
    directoryId?: string | null;
    directory?: MathDirectory | null;
    postSettings?: PostSetting[] | null;
    postAttachments?: PostAttachment[] | null;
}

export interface MathDirectory extends EntityWithName {
    rootDirectoryId?: string | null;
    rootDirectory?: MathDirectory | null;
    files?: MathFile[] | null;
    directories?: MathDirectory[] | null;
}

export interface PostSetting extends EntityWithGuidKey {
    isCommentsAllowed?: boolean;
    canBeRated?: boolean;
    postOnStartPage?: boolean;
    layout?: string | null;
    post?: Post | null;
    postType?: PostType | null;
    previewImageId?: string | null;
    previewImage?: MathFile | null;
    eventTime?: Date | null;
    eventLocation?: string | null;
}

export interface PostType extends EntityWithNameAndAlias {
    defaultPostsSettingsId?: string;
    defaultPostsSettings?: PostSetting | null;
    posts?: Post[] | null;
}

export interface PostAttachment extends EntityWithGuidKey {
    allowed?: boolean;
    postId?: string;
    post?: Post | null;
    fileId?: string;
    file?: MathFile | null;
}

export interface Professor extends EntityWithGuidKey {
    personId?: string;
    person?: Person | null;
    faculty?: string | null;
    department?: string | null;
    description?: string | null;
    mathNetLink?: string | null;
    status?: string | null;
    scientificTitle?: string | null;
    graduated?: GraduationPlace[] | null;
    theses?: Thesis[] | null;
    termPapers?: TermPaper[] | null;
    bibliographicIndexOfWorks?: ProfessorWork[] | null;
}

export interface GraduationPlace extends EntityWithGuidKey {
    professor?: Professor | null;
    professorId?: string;
    title?: string | null;
}

export interface Thesis extends EntityWithGuidKey {
    professor?: Professor | null;
    professorId?: string;
    title?: string | null;
}

export interface TermPaper extends EntityWithGuidKey {
    professor?: Professor | null;
    professorId?: string;
    title?: string | null;
}

export interface ProfessorWork extends EntityWithGuidKey {
    professor?: Professor | null;
    professorId?: string;
    title?: string | null;
}

export interface UserSetting extends EntityWithGuidKey {
    namespace?: string | null;
    key?: string | null;
    value?: string | null;
    userId?: string;
    user?: User | null;
}

export interface PostSeoSetting extends EntityWithGuidKey {
    url?: string | null;
    title?: string | null;
    description?: string | null;
    post?: Post | null;
    postKeywords?: PostKeyword[] | null;
}

export interface PostKeyword extends EntityWithGuidKey {
    keywordId?: string;
    keyword?: Keyword | null;
    postSeoSettingsId?: string;
    postSeoSettings?: PostSeoSetting | null;
}

export interface Keyword extends EntityWithNameAndAlias {
    posts?: PostKeyword[] | null;
}

export interface DashboardPageViewModel extends CommonAdminPageViewModel {
    frameworkVersion: string;
    dotnetVersion: string;
}

export interface EventViewModel extends PostViewModel {
    eventTime?: Date | null;
    eventLocation?: string | null;
}

export interface DirectoryViewModel {
    id?: string | null;
    name?: string | null;
    directories?: DirectoryViewModel[] | null;
    files?: FileViewModel[] | null;
    icon?: string | null;
}

export interface FileViewModel {
    id?: string | null;
    name?: string | null;
    extension?: string | null;
    directoryId?: string | null;
    icon?: string | null;
}

export interface UploadResultViewModel {
    totalFiles?: number;
    totalSize?: number;
    filesIds?: string[] | null;
    fileNames?: string[] | null;
}

export interface IndexFilesViewModel extends AdminPageBaseViewModel {
    directories: DirectoryViewModel2[];
    files: FileViewModel2[];
    currentDirectory: string;
}

export interface DirectoryViewModel2 {
    id: string;
    title: string;
    creationDate: string;
    fullPath: string;
}

export interface FileViewModel2 {
    id: string;
    title: string;
    creationDate: string;
    fullFilePath: string;
}

export interface CreateFolderViewModel extends AdminPageBaseViewModel {
    folderName: string;
    path: string;
}

export interface FroalaImagesResult {
    id?: string;
    url?: string | null;
}

export interface FroalaUploadResult {
    link?: string | null;
}

export interface IHeaderDictionary {
    Item?: any[];
    ContentLength?: number | null;
    Accept?: any[];
    AcceptCharset?: any[];
    AcceptEncoding?: any[];
    AcceptLanguage?: any[];
    AcceptRanges?: any[];
    AccessControlAllowCredentials?: any[];
    AccessControlAllowHeaders?: any[];
    AccessControlAllowMethods?: any[];
    AccessControlAllowOrigin?: any[];
    AccessControlExposeHeaders?: any[];
    AccessControlMaxAge?: any[];
    AccessControlRequestHeaders?: any[];
    AccessControlRequestMethod?: any[];
    Age?: any[];
    Allow?: any[];
    AltSvc?: any[];
    Authorization?: any[];
    Baggage?: any[];
    CacheControl?: any[];
    Connection?: any[];
    ContentDisposition?: any[];
    ContentEncoding?: any[];
    ContentLanguage?: any[];
    ContentLocation?: any[];
    ContentMD5?: any[];
    ContentRange?: any[];
    ContentSecurityPolicy?: any[];
    ContentSecurityPolicyReportOnly?: any[];
    ContentType?: any[];
    CorrelationContext?: any[];
    Cookie?: any[];
    Date?: any[];
    ETag?: any[];
    Expires?: any[];
    Expect?: any[];
    From?: any[];
    GrpcAcceptEncoding?: any[];
    GrpcEncoding?: any[];
    GrpcMessage?: any[];
    GrpcStatus?: any[];
    GrpcTimeout?: any[];
    Host?: any[];
    KeepAlive?: any[];
    IfMatch?: any[];
    IfModifiedSince?: any[];
    IfNoneMatch?: any[];
    IfRange?: any[];
    IfUnmodifiedSince?: any[];
    LastModified?: any[];
    Link?: any[];
    Location?: any[];
    MaxForwards?: any[];
    Origin?: any[];
    Pragma?: any[];
    ProxyAuthenticate?: any[];
    ProxyAuthorization?: any[];
    ProxyConnection?: any[];
    Range?: any[];
    Referer?: any[];
    RetryAfter?: any[];
    RequestId?: any[];
    SecWebSocketAccept?: any[];
    SecWebSocketKey?: any[];
    SecWebSocketProtocol?: any[];
    SecWebSocketVersion?: any[];
    SecWebSocketExtensions?: any[];
    Server?: any[];
    SetCookie?: any[];
    StrictTransportSecurity?: any[];
    TE?: any[];
    Trailer?: any[];
    TransferEncoding?: any[];
    Translate?: any[];
    TraceParent?: any[];
    TraceState?: any[];
    Upgrade?: any[];
    UpgradeInsecureRequests?: any[];
    UserAgent?: any[];
    Vary?: any[];
    Via?: any[];
    Warning?: any[];
    WebSocketSubProtocols?: any[];
    WWWAuthenticate?: any[];
    XContentTypeOptions?: any[];
    XFrameOptions?: any[];
    XPoweredBy?: any[];
    XRequestedWith?: any[];
    XUACompatible?: any[];
    XXSSProtection?: any[];
}

export interface Leader {
    position: string;
    professor: ProfessorHomeListViewModel;
}

export interface ProfessorHomeListViewModel {
    id: string;
    person: PersonViewModel;
}

export interface PersonViewModel {
    name: string;
    surname: string;
    middleName?: string | null;
    hasPhoto: boolean;
}

export interface NewsViewModel extends PostViewModel {
}

export interface BasePersonEditViewModel extends AdminPageBaseViewModel {
    id?: string | null;
    firstName: string;
    secondName: string;
    middleName?: string | null;
    birthDate: Date;
    phone?: string | null;
    photoId?: string | null;
}

export interface CreatePersonsViewModel extends BasePersonEditViewModel {
    id: string;
}

export interface EditPersonsViewModel extends BasePersonEditViewModel {
    id: string;
}

export interface IListMethodResultOfPerson {
    items?: Person[] | null;
    pagesCount?: number;
}

export interface BaseProfessorViewModel extends AdminPageBaseViewModel {
    id?: string;
    faculty: string;
    department: string;
    description: string;
    mathNetLink?: string | null;
    status?: string | null;
    scientificTitle?: string | null;
    graduated?: string[] | null;
    theses?: string[] | null;
    termPapers?: string[] | null;
    bibliographicIndexOfWorks?: string[] | null;
    availablePersons?: SelectListItem[] | null;
    personId: string;
}

export interface IListMethodResultOfProfessor {
    items?: Professor[] | null;
    pagesCount?: number;
}

export interface IndexSettingsViewModel extends AdminPageBaseViewModel {
    siteName: string;
    defaultTitleForNewsPage?: string | null;
    defaultTitleForHomePage?: string | null;
    perPageCount: number;
    titleDelimiter: string;
}

export interface IListMethodResultOfUserDto {
    items?: UserDto[] | null;
    pagesCount?: number;
}

export interface UserDto {
    id?: string;
    userName?: string | null;
    email?: string | null;
    emailConfirmed?: boolean;
    creationDate?: Date;
    person?: Person | null;
    personId?: string;
}

export interface BaseUserEditViewModel extends AdminPageBaseViewModel {
    id?: string | null;
    login?: string | null;
    personId: string;
    email: string;
    emailConfirmed?: boolean;
    persons?: ValueTupleOfStringAndString[] | null;
}

export interface ValueTupleOfStringAndString {
    item1?: string;
    item2?: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: Blob | null | undefined): Observable<string> {
    return new Observable<string>((observer) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            blob.text().then((text) => observer.next(text));
        }
    });
}